<template>
  <div class="ws-state-radio">
    <div
      v-if="isLoading.fetchedItems"
      class="loading-section"
    >
      <v-progress-circular
        size="20"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-radio-group
      v-else
      :value="getValue ? getValue(value) : value"
      @change="$_onChange($event)"
      row
      class="mt-1"
    >
      <v-radio
        v-for="(item,itemKey) in _items"
        :key="itemKey"
        :label="item.text"
        :value="getValue ? getValue(item.value) : item.value"
        class="mb-1"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  data(){
    return {
      isLoading: {
        fetchedItems: false,
      },
      fetchedItems: [],
    }
  },
  methods: {
    $_getDefaultValue() {
      if (this.defaultValue && !this.value) {
        this.$emit("input", this.defaultValue);
      }
    },
    async $_getItems() {
      this.isLoading.fetchedItems = true;
      const res = await this.$axios.get(this.getUrl, {params: this.params});
      this.fetchedItems = this.getItems
        ? this.getItems(res.data.data)
        : res.data.data;
      this.isLoading.fetchedItems = false;
    },
    $_onChange($event) {
      const value = this.setValue ? this.setValue($event, this._items) : $event;
      this.$emit('input', value);
    }
  },
  computed: {
    _items() {
      return this.getUrl
        ? this.fetchedItems
        : this.items;
    },
  },
  props: {
    value: {
      type: [Number, String, Array, Object],
      default: null,
    },
    items: {
      type: Array,
    },
    defaultValue: {
      type: [String, Number],
      default: null,
    },
    getItems: {
      type: Function,
    },
    getUrl: {
      type: String,
    },
    params: {
      type: Object,
    },
    getValue: {
      type: Function,
    },
    setValue: {
      type: Function,
    },
  },
  async mounted() {
    this.$_getDefaultValue();
    if (this.getUrl) await this.$_getItems();
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-radio.scss";
</style>